import cn from 'classnames'
import React from 'react'
import sanitize from 'sanitize-html'

import { Checkbox } from 'core-components/library/checkbox'
import { BP_TC_ITALY_ADDITION } from 'onboarding/components/page/bpTCReconfirmation/constants'

import styles from '../Body.module.scss'

interface AgreementSectionProps {
  disabled: boolean
  isAgreed: boolean
  onToggleAgreed: () => void
  showItalyAddition: boolean
  isItalyAgreed: boolean
  onToggleItalyAgreed: () => void
  texts: {
    mainText: string
    confirmationText: string
  }
}

export const AgreementSection: React.FC<AgreementSectionProps> = ({
  disabled,
  isAgreed,
  onToggleAgreed,
  showItalyAddition,
  isItalyAgreed,
  onToggleItalyAgreed,
  texts: { mainText, confirmationText },
}) => {
  return (
    <div
      className={cn(styles.confirmation, {
        [styles.success]: isAgreed && (!showItalyAddition || isItalyAgreed),
      })}
    >
      <div className={styles.checkbox}>
        <Checkbox disabled={disabled} checked={isAgreed} onChange={onToggleAgreed} />
        <div className={styles.text}>
          {mainText}
          <br />
          {confirmationText}
        </div>
      </div>

      {showItalyAddition && (
        <div className={cn(styles.checkbox, styles.longText)}>
          <Checkbox disabled={disabled} checked={isItalyAgreed} onChange={onToggleItalyAgreed} />
          <div
            className={styles.text}
            dangerouslySetInnerHTML={{
              __html: sanitize(BP_TC_ITALY_ADDITION),
            }}
          ></div>
        </div>
      )}
    </div>
  )
}
